import React, { useEffect, useCallback, useState} from 'react';
import {EFFECT_PRESETS_BUTTON} from 'constants/contextual-help.js';
import Documented from "components/help/Documented.js";
import {EFFECT_RETURN_PRESETS_BUTTON} from 'constants/contextual-help.js';
import {connect} from 'react-redux';

const EffectBottomToolbar = ({
    togglePresets,
    setContextualHelp,
    showPresets,
    effect,
    locked
}) => { 

    const toggleLock = useCallback(() => {
        effect.lock = !locked;
    }, [effect, locked]);

    return (
        <Documented
          element={showPresets ?  EFFECT_RETURN_PRESETS_BUTTON :
                   EFFECT_PRESETS_BUTTON}
          className="bottom-effect-toolbar">
          <img
            onClick={toggleLock}
            src={locked ? "/closed-padlock.png" :"/opened-padlock.png"} className="effect-lock"/>
          <img
            onClick={togglePresets}
            src="/floppy-disk.svg" className={showPresets ? "load-preset-button selected" : "load-preset-button"}/>
        </Documented> 
    );
};

const mapStateToProps = (state, props) => {
  return {
      locked: props.effect.locked
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EffectBottomToolbar);
